import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Select from 'react-select';
import FormControl from './FormControl';
import { DROPDOWN_SEARCH_MINIMUM } from '../../../constants';
import { pickDataAttributes } from '../../../Util';
import { checkError, onFocus, translationProps, rendererProps, autoComplete, selectOnChange } from '../ControlHelpers/SelectUtils.js';
import { kebabCase } from 'lodash';

export default class SelectControl extends FormControl {
  static propTypes = {
    children: PropTypes.any,
    multi: PropTypes.bool,
    onChange: PropTypes.func,
    onValueChange: PropTypes.func,
    valueKey: PropTypes.string.isRequired,
    dataValue: PropTypes.any,
    scrollContainerId: PropTypes.string,
    placeholderText: PropTypes.string,
    valueOverride: PropTypes.bool
  };

  static defaultProps = Object.assign({}, FormControl.defaultProps, {
    placeholderText: ""
  });

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.valueOverride && newProps.dataValue !== this.state.value) {
      this.onChange(newProps.dataValue, true);
    }
  }

  onChange = (val, skipValueChange) => {
    const value = selectOnChange(val, this.props, this.select, skipValueChange);
    this.setState({ ...this.state, value });
  }

  onBlur = () => {
    if (typeof this.props.onBlur === 'function') {
      this.props.onBlur(this.state.value);
    }
    this.checkError();
  }

  isValid() {
    let input = ReactDOM.findDOMNode(this.select).querySelector('input');
    if (input) {
      return input.validity.valid;
    }
  }

  onFocus = (e) => {
    onFocus(e, this.props);
  }

  displayHiddenInput = () => {
    const { value } = this.state;

    if (Array.isArray(value)) {
      return !value.length;
    }

    return !value;
  }

  checkError() {
    checkError(this.props, this.select);
  }

  render() {
    const { setError, name, ...props } = this.props;  // eslint-disable-line no-unused-vars
    const autocomplete = autoComplete(this.props);
    const dataAttributes = pickDataAttributes(this.props, 'select-control');
    if(!dataAttributes['data-action']){
      dataAttributes['data-action'] = name ? `select-${kebabCase(name)}` : 'select';
    }

    return (
      <React.Fragment>
        <Select
          {...props}
          {...translationProps}
          {...rendererProps(this.props.multi, this.props)}
          aria-labelledby={`${this.props.name}-label`}
          onBlur={this.onBlur}
          inputProps={{ id: name, ...dataAttributes, ...autocomplete }}
          ref={(i) => { this.select = i; }}
          onFocus={this.onFocus}
          searchable={this.props.options && !(this.props.options.length < DROPDOWN_SEARCH_MINIMUM)}
          value={this.state.value}
          onChange={this.onChange}
          name={this.props.multi ? `${name}[]` : name}
          scrollMenuIntoView={false}
          closeOnSelect={!this.props.multi}
          removeSelected={false}
          placeholder={this.props.placeholderText} />
        {this.displayHiddenInput() &&
          <input className="hidden-input" tabIndex="-1" name={this.props.multi ? `${name}[]` : name} required={this.props.required} />}
      </React.Fragment>
    );
  }
}
